export const createModalDelete = (type) => {
  return {
    isOpen: false,
    title: `Delete ${type}`,
    subTitle: `Are you sure to delete this ${type.toLowerCase()}.\n You can't undo this operation`,
  };
};

export const createNotifySuccess = (msg = `Operation performed correctly`) => {
  return {
    title: msg,
    type: "success",
  };
};

export const createNotifyError = (msg = `Error in the operation`) => {  
    return {
      title : switchMsg(msg),
      type: "error",
    };
};


  const switchMsg = (msg) => {   
    switch(msg) {
      case 'UserNotFoundException':        
        return "Usuario o contraseña incorrectos" ;
      case 'CodeMismatchException':
        return "El código introducido no es correcto" ;
      case 'NotAuthorizedException':
        return "Usuario o contraseña incorrectos";
      case 'UserNotConfirmedException': 
        return "El usuario no ha sido aún verificado";
      case 'UsernameExistsException':
        return "No se ha podido completar el registro, por favor comprueba que no te has registrado anteriormente";
      case 'InvalidParameterException':
        return "Algún parámetro introducido no pasa la validación";
      case 'NotValidateFields' :   
        return "Por favor introduce todos los parámetros obligatorios"    
      default:
        return <p>Lo sentimos, <br></br> algo ha ido mal</p>;
    }
  
  }


export const getFiltersPage = (page = 0, size = 10, order = "") => {
  return `?page=${page}&size=${size}` + (order.length > 0 ? `${order}` : "");
};

export const hasObjectAllValuesEmpty = (obj) => {
  if (obj)
    return Object.values(obj).every((e) => e === undefined || e === "" || typeof e === "undefined");
  return true;
};
